/**
 * Cards_behavior.js
 *
 * Title seems quite self explanatory.
 */

import { initializeUtagEvents } from './cards_behavior.analytics.js'

export function init(blockSelector) {
  if (!blockSelector) return

  // Show more info about the resource in the same card.
  const moreInfoBtns = document.querySelectorAll(`${blockSelector} .info-box-mobile .more-info, ${blockSelector} .card.hotel .more-info`)
  moreInfoBtns.forEach(moreInfoBtn => {
    moreInfoBtn.addEventListener('click', function (event) {
      const el = event.target
      el.classList.toggle('active')
      const infoBox = el.closest('.info-box-container, .card.hotel')?.querySelector('.info-box-services')
      if (infoBox) {
        infoBox.classList.toggle('active')
      }
    })
  })

  const horizontalCards = document.querySelectorAll(`${blockSelector} .horizontal-card`)
  horizontalCards.forEach(card => {
    const swiperSlidesCounter = card.querySelectorAll('.swiper-slide')

    if (swiperSlidesCounter.length <= 1) return

    const sliderControls = card.querySelectorAll('.slider-controls')
    sliderControls.forEach(sliderControl => {
      sliderControl.classList.remove('hidden')
    })
  })

  initializeUtagEvents(blockSelector)
}
